import {useLayoutEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {RadioItem, RadioItems} from "@/app/features/auth/components/radio_item/widget";
import {t} from "i18next";
import {s} from "@/app/utils/s";

const useWhoAreYou = () => {
  const [selectedItem, setSelectedItem] = useState<RadioItem | null>(null);

  const items: RadioItems = {
    items: [
      { id: 1, title: t(s.doctor), description: t(s.treatingThisIsMyMainGoal) },
      { id: 2, title: t(s.patient), description: t(s.iNeedASolutionToTheProblem) },
    ],
  };

  const next = () => {
    if (selectedItem === null) {
      return;
    }

  };

  return {
    selectedItem,
    setSelectedItem,
    items,
    next
  };
};

export default useWhoAreYou;